import { Skyline } from './components/Skyline.js'
import { Create } from './routes/Create.js'
import { Meeting } from './routes/Meeting.js'
import { t } from './lib/i18n.js'

/**
 * Two screens at the top level: create a link, or open one.
 *
 * No router library - there are exactly two paths, and the meeting screen
 * chooses what to render from server state rather than from the URL
 * (invariant 6: the link is the source of truth).
 */
export function App() {
  const token = window.location.pathname.replace(/^\/+|\/+$/g, '')

  return (
    <>
      {/* On every screen, not just the first. A wordmark that appears and
          disappears reads as a page title; a constant one is a product. On
          the recipient's side it is also the only thing telling him what this
          site is - he arrived from a link with no other context. */}
      {/* Not a link. As a home button it offered the recipient a way to
          abandon a half-finished meeting by tapping the logo, and gave the
          creator a route back that discards nothing - neither is a thing a
          masthead should do. */}
      <header className="masthead">
        <div className="brand">
          <Skyline className="skyline" />
          <span className="wordmark">{t('create.title')}</span>
        </div>
      </header>

      {token ? <Meeting token={token} /> : <Create />}
    </>
  )
}
